const ns = {
    namespace: "UuContentKit",
    cssPrefix: "uucontentkit",
    tag: function(component) {return ns.namespace + "." + component;},
    css: function(component) {return ns.cssPrefix + "-" + component;}
  };
  export default ns;


// WEBPACK FOOTER //
// ../.tmp/temp-1.js